module.exports = __webpack_public_path__ + "img/1535514406.c69db97c.jpg";